import {
  EnvironmentProviders,
  inject,
  provideEnvironmentInitializer,
  Provider,
} from '@angular/core';
import {
  ApplicationStore,
  getModuleGroupByName,
  SOFTLINE_FEATURE_APPLICATIONS,
} from '@softline/application';
import {
  provideSoftAppsModule,
  withLazySoftAppsModuleTranslation,
  withSoftAppsModuleRoutes,
} from '@softapps/core';
import { Store } from '@softline/core';
import { SOFTLINE_FEATURE_TRANSLATION, TranslationStore } from '@softline/ui-core';
import { default as de } from '../i18n/de.json';
import { default as deTitles } from '../i18n/de.titles.json';
import { objektabfrageRoutes } from './objektabfrage.routes';
import { SOFTLINE_PERMISSION_OBJECT_QUERY } from './objektabfrage.shared';

export const objektabfrageProviders: Array<Provider | EnvironmentProviders> = [
  provideEnvironmentInitializer(() => {
    const store = inject(Store);
    store.commit(SOFTLINE_FEATURE_TRANSLATION, TranslationStore.mutations.add, {
      module: 'objektabfrage',
      language: 'de',
      translations: de,
    });
    store.commit(SOFTLINE_FEATURE_APPLICATIONS, ApplicationStore.mutations.add, {
      name: 'Objektabfrage',
      icon: 'fa-regular fa-database',
      route: '/objektabfrage',
      permission: SOFTLINE_PERMISSION_OBJECT_QUERY,
      group: getModuleGroupByName('Stammdaten'),
    });
  }),
];

export function provideObjektabfrageModule() {
  return [
    provideSoftAppsModule(
      {
        name: 'wws/objektabfrage',
        title: 'Objektabfrage',
        icon: 'fa-regular fa-database',
        route: '/objektabfrage',
        permission: SOFTLINE_PERMISSION_OBJECT_QUERY,
        group: getModuleGroupByName('Stammdaten'),
      },
      withSoftAppsModuleRoutes({ app: objektabfrageRoutes }),
      withLazySoftAppsModuleTranslation({
        eager: { de: deTitles },
        lazy: { de: () => import('../i18n/de.json') },
      })
    ),
  ];
}
